const REFERENCE_VIEW = 1001;
const REFERENCE_EDIT = 1002;

const USERS_VIEW = 2001;
const USERS_EDIT = 2002;

const COURSE_VIEW = 3001;
const COURSE_EDIT = 3002;


export default {
    REFERENCE_VIEW: REFERENCE_VIEW,
    REFERENCE_EDIT: REFERENCE_EDIT,
    USERS_VIEW: USERS_VIEW,
    USERS_EDIT: USERS_EDIT,
    COURSE_VIEW: COURSE_VIEW,
    COURSE_EDIT: COURSE_EDIT
}